/**
 * @module events/types/click
 */

/**
 * @type {string}
 */
export default 'click'
